/**
 * 输出质量前端策略。这里只做提前校验，后端仍会再次校验分辨率和节点参数。
 */
export const MINIMUM_OUTPUT_RESOLUTION = '2K'
export const OUTPUT_RESOLUTION_OPTIONS = Object.freeze(['2K', '4K'])
export const IMAGE_GENERATION_MODEL = 'gpt-image-2-official'
export const DEFAULT_GENERATION_QUALITY = 'medium'
export const GENERATION_QUALITY_OPTIONS = Object.freeze([
  Object.freeze({ value: 'medium', label: '中配', points: 15, description: '默认；可重试失败时自动转高配，不重复扣费' }),
  Object.freeze({ value: 'high', label: '高配', points: 60, description: '直接使用高质量生成；失败后不降级' })
])
export const OUTPUT_DIMENSIONS = Object.freeze({
  '2K': Object.freeze({ width: 2048, height: 1152 }),
  '4K': Object.freeze({ width: 3840, height: 2160 })
})

export function normalizeOutputResolution(value) {
  return String(value || '').trim().toUpperCase() === '4K'
    ? '4K'
    : MINIMUM_OUTPUT_RESOLUTION
}

export function normalizeGenerationQuality(value) {
  return String(value || '').trim().toLowerCase() === 'high' ? 'high' : DEFAULT_GENERATION_QUALITY
}

export function outputDimensions(value) {
  return OUTPUT_DIMENSIONS[normalizeOutputResolution(value)]
}

export function generationPoints(value) {
  const quality = normalizeGenerationQuality(value)
  const option = GENERATION_QUALITY_OPTIONS.find(item => item.value === quality)
  return option ? option.points : GENERATION_QUALITY_OPTIONS[0].points
}

export function isResolutionNode(node) {
  const text = [
    node && node.fieldName,
    node && node.nodeName,
    node && node.description
  ].filter(Boolean).join(' ').toLowerCase()

  return /resolution|pixel|分辨率|像素|输出尺寸|输出大小/.test(text)
}

export function normalizeResolutionNode(node) {
  if (!isResolutionNode(node)) return node
  return {
    ...node,
    fieldValue: normalizeDynamicResolutionValue(node.fieldValue)
  }
}

export function isLowResolutionOption(option) {
  const label = String(option && option.label || '').trim().toLowerCase()
  return /(^|[^\d])1\s*k([^\d]|$)|^1(?:\.0+)?$|1024|低清|标清/.test(label)
}

function normalizeDynamicResolutionValue(value) {
  if (typeof value === 'number' && Number.isFinite(value)) {
    if (value <= 4) return Math.max(2, value)
    if (value < 2000) return 2048
    return value
  }

  const text = String(value == null ? '' : value).trim()
  const match = text.match(/^(\d+(?:\.\d+)?)\s*(k)?$/i)
  if (!match) return value

  const amount = Number(match[1])
  if (match[2]) return amount < 2 ? MINIMUM_OUTPUT_RESOLUTION : value
  if (amount <= 4) return String(Math.max(2, amount))
  return amount < 2000 ? '2048' : value
}
